export const STORAGE_KEYS = {
	BACKUP_REMINDER: 'backup-reminder',
	DEVICE_ID: 'deviceId',
	LEGACY_ROOM_MIGRATIONS: 'legacy-room-migrations',
	PREFERRED_LANGUAGE: 'preferredLanguage',
	ROOM: 'room',
	ROOM_JOIN_STRATEGY: 'room-join-strategy',
	SELECTED_PROFILE_ID: 'selectedProfileId-local',
	SHOW_COMPARISON_CHARTS: 'adameter-show-comparison',
} as const;

export type StorageKey = (typeof STORAGE_KEYS)[keyof typeof STORAGE_KEYS];

export function getItem(key: StorageKey): string | null {
	if (typeof window === 'undefined') {
		return null;
	}
	return window.localStorage.getItem(key);
}

export function setItem(key: StorageKey, value: string): void {
	if (typeof window === 'undefined') {
		return;
	}
	window.localStorage.setItem(key, value);
}

export function removeItem(key: StorageKey): void {
	if (typeof window === 'undefined') {
		return;
	}
	window.localStorage.removeItem(key);
}

export function clear(): void {
	if (typeof window === 'undefined') {
		return;
	}
	window.localStorage.clear();
}
